import * as urls from '../config'
import axios from 'axios'

export default {
  getPagina (slug, unidade) {
    let service = urls.WP_URL + 'pagina-extra-por-unidade/' + unidade + '/' + slug + '?_embed'
    return axios.get(service)
    .then(response => {
      return response.data[0]
    })
    .catch(error => {
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/api/PaginaExtraService.js